import React, { useEffect, useContext, useState, useActionState } from 'react';
import Icon_Close from '../../Assets/Icons/Icon_Close.png';
import { Context_UI } from '../../Contexts/Context_UI';
import UI_Horizontal_Tabs from '../ERUMAUI/UI_Horizontal_Tabs';
import UI_Icon from '../ERUMAUI/UI_Icons';
import UI_Form from '../ERUMAUI/UI_Form';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Input_Text_Long from '../ERUMAUI/UI_Input_Text_Long';
import UI_Dropdown from '../ERUMAUI/UI_Dropdown';
import { useTemplating } from '../../Contexts/Context_Templating';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import { useAccounts } from '../../Contexts/Context_Accounts';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import UI_Button from '../ERUMAUI/UI_Button';
import UI_Divider from '../ERUMAUI/UI_Divider';
import Header from '../../Assets/Images/Form_Header.png';
import UI_ChipGroup from '../ERUMAUI/UI_ChipGroup';

export default function Document_Schedule({ Data }) {
    const UI = useContext(Context_UI);
    const { Status_Parse, Time_Parse, Time_Range_Parse } = useScheduleManagement();
    const { Accounts_Fetch_ByID_Many_Basic } = useAccounts();
    const { Room_Get_Address } = useMapRenderer();

    const [Accounts, Accounts_Set] = useState({});

    useEffect(() => {
        const allIDs = [
            Data.Requester?.RequesterID,
            Data.Approval?.Initial?.ApproverID,
            Data.Approval?.Final?.ApproverID
        ];

        Accounts_Fetch_ByID_Many_Basic(allIDs).then(Accounts_Set);
    }, [Data]);

    const getName = (id) => Accounts[id]?.Name || "Loading...";
    const getEmail = (id) => Accounts[id]?.Email || "Loading...";
    const now = new Date();

    return (
        <ui-document>
            <ui-document-content>
                <ui-document-header>
                    <img src={Header} draggable="false" loading="lazy" className='Document_Header' />
                    <h4 className='General_Paragraph' style={{ textAlign: "center" }}>
                        GS Form 4
                    </h4>
                    <h2 className='General_Title' style={{ textAlign: "center" }}>
                        General Services Unit
                    </h2>
                    <h4 className='General_Paragraph' style={{ textAlign: "center" }}>
                        Reservation Request Form
                    </h4>
                </ui-document-header>
                <ui-document-content-main>
                    <UI_Divider Text="Activity information" />
                    <h2 className='General_Paragraph' style={{ marginBottom: "10px" }}>
                        {Data.Name}
                    </h2>
                    <p className='General_Paragraph' style={{ marginBottom: "30px" }}>
                        {Data.Description}
                    </p>
                    <div style={{ display: "grid", gridTemplateColumns: "200px 1fr", gap: "10px", alignItems: "center" }}>
                        <p className='General_Paragraph'>
                            Request status:
                        </p>
                        <UI_ChipGroup Items={Status_Parse(Data)} />
                        <p className='General_Paragraph'>
                            Date reserve:
                        </p>
                        <p className='General_Paragraph'>
                            <b>{Time_Parse(Data.Time.Start, "Date")}</b>
                        </p>
                        <p className='General_Paragraph'>
                            Time from:
                        </p>
                        <p className='General_Paragraph'>
                            <b>{Time_Parse(Data.Time.Start, "Time")}</b>
                        </p>
                        <p className='General_Paragraph'>
                            Time to:
                        </p>
                        <p className='General_Paragraph'>
                            <b>{Time_Parse(Data.Time.End, "Time")}</b>
                        </p>
                        <p className='General_Paragraph'>
                            Location:
                        </p>
                        <p className='General_Paragraph'>
                            <b>{Room_Get_Address(Data.RoomID)}</b>
                        </p>
                    </div>
                    <UI_Divider Text="Approval information" />
                    <div style={{ display: "grid", gridTemplateColumns: "200px 1fr", gap: "10px" }}>
                        <p className='General_Paragraph'>
                            Date applied:
                        </p>
                        <p className='General_Paragraph'>
                            <b>{Time_Parse(Data.DateCreated)}</b>
                        </p>
                        <p className='General_Paragraph'>
                            Date approved by OSA:
                        </p>
                        <p className='General_Paragraph'>
                            {Data.Approval.Initial.State == "Approved" ?
                                <b>{Time_Parse(Data.Approval.Initial.DateApproved)}</b>
                                :
                                Data.Approval.Initial.State == "Pending" ?
                                    <b>Pending approval</b>
                                    :
                                    Data.Approval.Initial.State == "Rejected" ?
                                        <b>Rejected</b>
                                        :
                                        ""
                            }
                        </p>
                        <p className='General_Paragraph'>
                            OSA representative:
                        </p>
                        <p className='General_Paragraph'>
                            {Data.Approval.Initial.State == "Approved" ?
                                <b>{getName(Data.Approval.Initial.ApproverID)}</b>
                                :
                                Data.Approval.Initial.State == "Pending" ?
                                    <b>-</b>
                                    :
                                    Data.Approval.Initial.State == "Rejected" ?
                                        <b>{getName(Data.Approval.Initial.ApproverID)}</b>
                                        :
                                        ""
                            }
                        </p>
                        <p className='General_Paragraph'>
                            Date approved by GSU:
                        </p>
                        <p className='General_Paragraph'>
                            {Data.Approval.Final.State == "Approved" ?
                                <b>{Time_Parse(Data.Approval.Final.DateApproved)}</b>
                                :
                                Data.Approval.Final.State == "Pending" ?
                                    <b>Pending approval</b>
                                    :
                                    Data.Approval.Final.State == "Rejected" ?
                                        <b>Rejected</b>
                                        :
                                        ""
                            }
                        </p>
                        <p className='General_Paragraph'>
                            GSU representative:
                        </p>
                        <p className='General_Paragraph'>
                            {Data.Approval.Initial.State == "Approved" ?
                                <b>{getName(Data.Approval.Final.ApproverID)}</b>
                                :
                                Data.Approval.Initial.State == "Pending" ?
                                    <b>-</b>
                                    :
                                    Data.Approval.Initial.State == "Rejected" ?
                                        <b>{getName(Data.Approval.Final.ApproverID)}</b>
                                        :
                                        ""
                            }
                        </p>
                    </div>
                    <UI_Divider Text="Requisitioner information" />
                    <div style={{ display: "grid", gridTemplateColumns: "200px 1fr", gap: "10px" }}>
                        <p className='General_Paragraph'>
                            Applicant name:
                        </p>
                        <p className='General_Paragraph'>
                            <b>{getName(Data.Requester.RequesterID)}</b>
                        </p>
                        <p className='General_Paragraph'>
                            Applicant email:
                        </p>
                        <p className='General_Paragraph'>
                            <b>{getEmail(Data.Requester.RequesterID)}</b>
                        </p>
                    </div>
                    <UI_Divider Text="Attendee information" />
                    <div style={{ display: "grid", gridTemplateColumns: "200px 1fr", gap: "10px" }}>
                        <p className='General_Paragraph'>
                            Number of attendees:
                        </p>
                        <p className='General_Paragraph'>
                            <b>{Data.Activity.Attendees.Names.length > 0 ? Data.Activity.Attendees.Names.length : "None listed"}</b>
                        </p>
                    </div>
                    {Data.Activity.Attendees.Names.length > 0 ?
                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: "5px", marginTop: "10px" }}>
                            {Data.Activity.Attendees.Names.map((Item) => (
                                <>
                                    <p className='General_Paragraph' style={{ margin: "0" }}>
                                        {Item}
                                    </p>
                                </>
                            ))}
                        </div>
                        :
                        ""
                    }
                </ui-document-content-main>
                <ui-document-footer>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: "5px", marginTop: "10px" }}>
                        <p className='General_Paragraph'>
                            Document generated {Time_Parse(now)}
                        </p>
                        <p className='General_Paragraph'>
                            <b>
                                Page 1 of 1
                            </b>
                        </p>
                    </div>
                </ui-document-footer>
            </ui-document-content>
        </ui-document>
    );
}
